export default "__VITE_ASSET__Ba92X8Lf__"